import { create } from "zustand";

import {
    ANALYZE_COMPARISON_MODES,
    ANALYZE_DATE_PRESETS,
    DEFAULT_ANALYZE_TAB,
} from "../constants";
import { AnalyzeComparisonMode, AnalyzeDatePreset, AnalyzeTab } from "../types";

interface AnalyzeStore {
    tabId: AnalyzeTab;
    setTabId: (tabId: AnalyzeTab) => void;
    // in-memory on purpose, kept only while on the analyze view
    metricsDatePreset: AnalyzeDatePreset;
    setMetricsDatePreset: (metricsDatePreset: AnalyzeDatePreset) => void;
    metricsComparisonMode: AnalyzeComparisonMode;
    setMetricsComparisonMode: (
        metricsComparisonMode: AnalyzeComparisonMode
    ) => void;
}

export const useAnalyzeStore = create<AnalyzeStore>((set) => ({
    tabId: DEFAULT_ANALYZE_TAB,
    setTabId: (tabId) => set({ tabId }),
    metricsDatePreset: ANALYZE_DATE_PRESETS.LAST_7_DAYS,
    setMetricsDatePreset: (metricsDatePreset) => set({ metricsDatePreset }),
    metricsComparisonMode: ANALYZE_COMPARISON_MODES.PREVIOUS_RANGE,
    setMetricsComparisonMode: (metricsComparisonMode) =>
        set({ metricsComparisonMode }),
}));
